export default __webpack_public_path__ + "static/media/weightlossregime@2x.93277064.jpg";